module.exports = __webpack_public_path__ + "static/b8a45451bdca296cb0139e4b9146c87f.svg";